export default __webpack_public_path__ + "static/media/twitter.780d06d4.svg";